<chat-mensagem-header class="chat-header"
  [chat]="chat()"
  (sairChatHandler)="removerParticipante($event)"
  (chatParticipantesHandler)="chatParticipantes($event)"
  (excluirChatHandler)="excluirChat($event)"
  (chatFormHandler)="chatForm($event)"
  (fecharChatHandler)="cancelForm()">
</chat-mensagem-header>

<div class="content">
  @if (activeCard === 'form') {
    <form [formGroup]="chatGrupoForm" name="chatGrupoForm"
      (ngSubmit)="salvarChatGrupo()"
      (keydown.enter)="salvarChatGrupo(); $event.preventDefault();"
      >
      <div class="image-box-capa">
        @if (capa?.id) {
          <img class="img-capa avatar" [src]="capa.conteudo|safeResourceUrl">
        }
        @if (!capa?.id) {
          <img class="img-capa avatar" src="assets/images/avatars/User.png">
        }
        <button mat-icon-button type="button" (click)="uploadImagemCapa()">
          @switch (!!capa?.id === true) {
            @case (true) {
              <mat-icon>mode_edit</mat-icon>
            }
            @case (false) {
              <mat-icon>photo</mat-icon>
            }
          }
        </button>
      </div>
      <mat-form-field floatLabel="auto" [subscriptSizing]="'dynamic'">
        <mat-label>Nome</mat-label>
        <input matInput #nome
          name="nome"
          formControlName="nome"
          shouldLabelFloat="false"
          required
          maxlength="255" upperCase>
        <mat-hint align="end">{{nome.value.length}} / 255</mat-hint>
      </mat-form-field>
      <mat-form-field floatLabel="auto" [subscriptSizing]="'dynamic'">
        <mat-label>Descrição</mat-label>
        <textarea formControlName="descricao"
          matInput #descricao
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          shouldLabelFloat="false"
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="10"
        maxlength="255" minlength="3" upperCase></textarea>
        <mat-hint align="end">{{descricao.value.length}} / 255</mat-hint>
        @if (chatGrupoForm.get('descricao').hasError('formError')) {
          <mat-error>
            {{chatGrupoForm.get('descricao').errors.formError}}
          </mat-error>
        }
      </mat-form-field>
      @if (chatGrupoForm.hasError('rulesError')) {
        <mat-error>{{chatGrupoForm.errors.rulesError}}</mat-error>
      }
      <div class="actions">
        @if (!saving()) {
          <button mat-raised-button color="primary" type="submit" [disabled]="chatGrupoForm.invalid">
            SALVAR
          </button>
        }
        @if (!saving()) {
          <button mat-raised-button color="warn" type="button" (click)="cancelForm()">
            CANCELAR
          </button>
        }
        @if (saving()) {
          <mat-spinner color="primary" diameter="24"></mat-spinner>
        }
      </div>
    </form>
  }
  @if (activeCard !== 'form') {
    <form class="space-y-2">
      <image-cropper
        #imgCapaCropComponent
        [imageChangedEvent]="imagemCapaEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="1/1"
        [resizeToWidth]="254"
        [autoCrop]="false"
        format="jpeg"
        [roundCropper]="true"
        (imageCropped)="imagemCapaCropped($event)">
      </image-cropper>
      @if (chatGrupoForm.hasError('rulesError')) {
        <mat-error>{{chatGrupoForm.errors.rulesError}}</mat-error>
      }
      <div class="actions">
        @if (!saving()) {
          <button mat-raised-button color="primary" (click)="cropImgCapa()"
            >
            RECORTAR
          </button>
        }
        <button mat-raised-button color="warn" type="button" (click)="cancelCrop()">
          CANCELAR
        </button>
      </div>
    </form>
  }
  <input hidden type="file"
    (change)="changeImgCapaUpload($event)"
    name="imgCapaUpload"
    #imgCapaUpload
    accept="{{uploadImagesMimeTypes}}">
</div>
